import React, {useEffect} from "react";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import useCoupon from "./useCoupon";

export default function () {
  const {handleSubmit, setErrors, couponFields, setData} = useCoupon();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('coupons/create').then(res => {
      setData(res.data.data);
    });
  }, []);

  const addCoupon = data => {
    axios.post('coupons', data).then(res => {
      navigate('/coupons');
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data?.errors || {});
      }
    });
  }

  return (
    <Card title="Add coupon">
      <form className="form w-100" onSubmit={handleSubmit(addCoupon)}>
        {couponFields}

        <SubmitButton title="Add"/>
      </form>
    </Card>
  );
}